var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlreadyAssignedUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D3EAFF;}\r\n\t.st1{fill:#278DEC;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,23.7L12,23.7C5.5,23.7,0.3,18.5,0.3,12l0,0C0.3,5.5,5.5,0.3,12,0.3l0,0c6.5,0,11.7,5.2,11.7,11.7l0,0 C23.7,18.5,18.5,23.7,12,23.7z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.5,5.6V4.3h-1.3v1.3H8.8V4.3H7.5v1.3H4.3v6.3h1.3v-1.2h12.9v7.8h-6.1h-0.3h-0.3v1.3h0.3h0.3h7.4V5.6H16.5z  M18.4,9.4H5.6V6.8h1.9v1.3h1.3V6.8h6.4v1.3h1.3V6.8h1.9L18.4,9.4L18.4,9.4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 7.9,
    cy: 14.6,
    rx: 1.8,
    ry: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.4,18.6c-0.3-0.6-0.9-1.2-1.7-1.5C9.4,17,9.2,17,9,17.1c-0.4,0.2-0.7,0.3-1.1,0.3s-0.8-0.1-1.1-0.3 c-0.2-0.1-0.4-0.1-0.6,0c-0.8,0.3-1.4,0.9-1.7,1.5c-0.3,0.5,0.1,1,0.7,1h5.7C11.2,19.7,11.6,19.1,11.4,18.6z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlreadyAssignedUser);
export default __webpack_public_path__ + "static/media/alreadyAssignedUser.cedd81df49d898197b42379fc9e057d1.svg";
export { ForwardRef as ReactComponent };